// src/services/publicVehicle.service.ts
import api from "./api";

export const getPublicVehicles = async (params: {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
  search?: string;
  make?: string;
  fuel?: string;
  minPrice?: number;
  maxPrice?: number;
  year?: string;
  maxKm?: string;
  city?: string;
  bodyType?: string;
  category?: string;
  verifiedSeller?: boolean;
}) => {
  const response = await api.get("/vehicle/all", { params });
  return response.data;
};

export const getPublicVehicleById = async (id: string, params?: { ref?: string; source?: string }) => {
  const response = await api.get(`/vehicle/all/${id}`, { params });
  return response.data;
};

export const getVehiclesForComparison = async (ids: string[]) => {
  const response = await api.post("/vehicle/compare", { ids });
  return response.data;
};
